// imports shared across all about templates
require('../about/base/imports');

// modules
require('../site_scripts/mtc_youtube_overlay');
require('../global/read-more');
require('../about/modules/timeline-slider');
// require('../about/modules/foundation-slider');
require('../about/modules/tabs');
require('../about/modules/team-member-popup');
require('../about/modules/show-nav-buttons');
require('../about/modules/sticky-nav');
require('../about/modules/highlight-nav');
require('../about/modules/click-nav');

// about page styles
require('../../styles/entry/about.less')
